import React from 'react';
import { Popover } from 'antd';
import styles from './markTip.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import SiriusCheckbox from '../Checkbox';
import { getIn18Text } from 'api';
export const PersonaMarkCheckbox = props => {
    const { value: checked, onChange, style, testId } = props;
    const tipContent = (React.createElement("div", { className: styles.personalMarkTipContent },
        React.createElement("div", { className: styles.image }),
        React.createElement("div", { className: styles.txt }, getIn18Text('markTipContent'))));
    return (React.createElement("div", { className: styles.personaMarkCheckboxWrap, style: style },
        React.createElement("div", { className: styles.personalMarkCheckbox, "data-test-id": testId, "data-test-check": checked, onClick: () => {
                onChange && onChange(!checked);
            } },
            React.createElement(SiriusCheckbox, { checked: checked })),
        React.createElement("div", { className: styles.personalMarkTip }, getIn18Text('markTip')),
        React.createElement(Popover, { overlayClassName: styles.personalMarkTipContentWrap, content: tipContent, placement: "bottom", arrowPointAtCenter: true },
            React.createElement(IconCard, { className: `dark-invert ${styles.personalMarkedTipIcon}`, style: { width: 16, height: 16, marginLeft: 4 }, type: "tongyong_cuowutishi_xian" }))));
};
